import React from "react";
import PropTypes from "prop-types";
import { Card, CardWrapper, StyledHeader } from "./AuthLayout.styled";
import fortcoreLogo from "../assets/fortcore-alt.png";
import { Link } from "react-router-dom";

const AuthLayout = ({ children }) => {
	return (
		<>
			<StyledHeader>
				<div className='content'>
					<Link to='/'>
						<img src={fortcoreLogo} alt='fortcore logo' />
					</Link>
					<h5>Super Admin</h5>
				</div>
			</StyledHeader>

			<CardWrapper>
				<Card>{children}</Card>
			</CardWrapper>
		</>
	);
};

AuthLayout.propTypes = {
	children: PropTypes.node,
};

export default AuthLayout;
